<template>
  <div class="calendar-navigation" :class="darkMode ? 'dark' : ''">
    <div class="datewrapper">
      <UIDatepicker class="date"
        @update-model="changeDate"
        :value="calendarDate"
        :locale="location.locale"
        :options="{ defaultDate: calendarDate, altFormat: 'F J' }"
        :disabled="!isNetworkAvailable"
        :darkMode="darkMode"
      />
      <div class="noclickoverlay" v-if="!isNetworkAvailable"></div>
    </div>
    <UIButton
      :ghost="true"
      @click="$emit('now')"
      class="now"
      v-if="isNetworkAvailable"
    >{{ $t("Now") }}</UIButton>
    <div v-else class="safetymodemessage f5">
      <svg>
        <use xlink:href="#icon-cloud-unavailable"></use>
      </svg>
      <span>
        {{ $t("You are looking at an offline version of this page saved on") }} {{ dateLastSeen }}.
        <a
          href="https://svr.li/k/234"
          rel="noopener"
          target="_blank"
        >{{ $t("Learn more about Safety Mode.") }}</a>
      </span>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import moment from 'moment-timezone';
import UIDatepicker from '@/core/shared/components/ui/UIDatepicker';
import UIButton from '@/core/shared/components/ui/UIButton';

@Component({
  components: {
    UIButton,
    UIDatepicker,
  },
  props: {
    location: {
      type: Object,
      required: true,
    },
    calendarDate: {
      type: String,
      required: true,
    },
    isNetworkAvailable: {
      type: Boolean,
      required: true,
    },
    momentLastConnected: {
      type: [String, null],
    },
    darkMode: {
      type: Boolean,
      required: false,
    },
  },
})
export default class CalendarNavigation extends Vue {
  get dateLastSeen () {
    if (this.momentLastConnected) return moment(this.momentLastConnected).format('LLLL');
  }

  changeDate (selectedDate) {
    this.$emit('setCalendarDate', selectedDate);
  }

  now () {
    this.$emit('now');
  }
}
</script>

<style scoped lang="postcss">
@import "core/shared/styles";

.calendar-navigation {
  display: flex;
  align-items: center;

  & .datewrapper {
    flex: 1 0 auto;
    margin: 0 auto;
    position: relative;

    @media (--tablet) {
      flex: 0 0 auto;
      padding-right: var(--spacingSm);
    }

    & .noclickoverlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      cursor: not-allowed;
      z-index: 1;
    }
  }

  & .now {
    display: none;

    @media (--tablet) {
      display: block;
    }
  }

  & .safetymodemessage {
    color: var(--colorErrorFlat);
    display: flex;
    align-items: center;

    & svg {
      fill: var(--colorErrorFlat);
      width: 2.5rem;
      height: 2.5rem;
      margin-right: var(--spacingSm);
    }

    & a {
      text-decoration: underline;
      color: var(--colorErrorFlat);
    }
  }
}

.calendar-navigation.dark .now {
  background-color: var(--darkModeColorDarkBackground) !important;
  color: var(--darkModeColorText) !important;
}

.calendar-navigation.dark .datewrapper .date >>> .relative .ui-datepicker {
  background-color: var(--darkModeColorDarkBackground) !important;
  color: var(--darkModeColorText) !important;
}
</style>
